/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useState, Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Popover, Select, MenuItem, FormControl, Tooltip } from "@mui/material";
import { ReactComponent as SettingsIcon } from "assets/images/icons/common/settings-with-border.svg";
import LabelledField from "components/labelled-field";
import { isArrayNotEmpty, isStringNotEmpty } from "utils/empty-exists";
import {
    DOCUMENT_FORMAT_OPTIONS,
    // DOCUMENT_STYLES,
    DOCUMENT_TARGET_OPTIONS,
    DOCUMENT_FORMATS,
    DOCUMENT_TARGETS,
    DOCUMENT_LIST_STYLE_OPTIONS,
    DOCUMENT_LIST
} from "cms/documents/document/helpers";

const SettingsDialog = (props) => {
    
    const {
        listStyle,
        onChangeListStyle,
        settings,
        onChangeSettings,
    } = props || {};
    
    // const { style: _style, format: _format, target: _target } = settings || {}
    const { style, format: _format, target: _target } = settings || {};
    const { t } = useTranslation();
    
    const formatOptions = DOCUMENT_FORMAT_OPTIONS;
    const targetOptions = DOCUMENT_TARGET_OPTIONS;
    const DEFAULT_LIST_STYLE = DOCUMENT_LIST.ICON;
    // const DEFAULT_STYLE = DOCUMENT_STYLES.BODY
    const DEFAULT_FORMAT = DOCUMENT_FORMATS.TITLE_SIZE;
    const DEFAULT_TARGET = DOCUMENT_TARGETS.NEW;
    
    // const [style, setStyle] = useState(_style || DEFAULT_STYLE) // no UI to modify style
    const [format, setFormat] = useState(_format || DEFAULT_FORMAT);
    const [target, setTarget] = useState(_target || DEFAULT_TARGET);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const hasSelectedStyleOption = !!listStyle;
    
    const onChangeListStyleHandler = (event) => {
        const value = event.target.value;
        const updatedValue = isStringNotEmpty(value) ? value : DEFAULT_LIST_STYLE;
        onChangeListStyle(updatedValue);
    };
    
    const onChangeFormat = (event) => {
        const value = event.target.value;
        setFormat(value);
        const updatedValue = isStringNotEmpty(value) ? value : DEFAULT_FORMAT;
        const nextSettings = { ...settings, style, format: updatedValue, target };
        onChangeSettings(nextSettings);
    };

    const onChangeTarget = (event) => {
        const value = event.target.value;
        setTarget(value);
        const updatedValue = isStringNotEmpty(value) ? value : DEFAULT_TARGET;
        const nextSettings = { ...settings, style, format, target: updatedValue };
        onChangeSettings(nextSettings);
    };

    return (
        <Fragment>
            <div style={{
                paddingTop: 12, display: "flex", flexDirection: "row", flexWrap: "nowrap", alignItems: "flex-end",
            }}
            >

                {/*  Presentation Style - Select */}
                <LabelledField
                    label={t("commons.presentationStyle")}
                    // className={`labelField max-width-40`}
                    className={"labelField presentation-style-control"}
                >
                
                    {isArrayNotEmpty(DOCUMENT_LIST_STYLE_OPTIONS) && listStyle &&
                    <FormControl sx={{ mt: 1, mb: 1, width: "100%" }} size="small">
                        {hasSelectedStyleOption &&
                            <Select
                                labelId="document-select"
                                id="document-style-select"
                                value={listStyle}
                                fullWidth={true}
                                variant="outlined"
                                onChange={(event) => onChangeListStyleHandler(event)}
                            >
                                {DOCUMENT_LIST_STYLE_OPTIONS.map((option, index) =>
                                    (
                                        <MenuItem
                                            key={index}
                                            value={option?.value}
                                        >
                                            {option?.name}
                                        </MenuItem>
                                    )
                                )}
                            </Select>
                        }
                    </FormControl>
                    }
                </LabelledField>
            
            
            
            
                {/*  Settings Dialog - Gear  */}
                <Tooltip
                    title={t("commons.documentSettings")}
                    placement="top"
                    arrow
                    classes={{ arrow: "arrow", tooltip: "tooltip" }}
                >
                    <SettingsIcon
                        onClick={(event) => setAnchorEl(event.currentTarget)}
                        style={{ marginLeft: 12, marginBottom: 12 }}
                    />
                </Tooltip>
                <Popover
                    open={open}
                    anchorEl={anchorEl}
                    onClose={() => setAnchorEl(null)}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}
                    placement='top-end'
                    className='settings-container'
                >
                    <h5>{t("commons.documentSettings")}</h5>
                    <LabelledField label={t("commons.displayAs")} className='labelField'>
                        {isArrayNotEmpty(formatOptions) &&
                        <FormControl sx={{ mt: 1, mb: 1, width: "100%" }} size="small">
                            <Select
                                labelId='document-select'
                                id='document-style-select'
                                value={format}
                                fullWidth={true}
                                variant='outlined'
                                onChange={(event) => onChangeFormat(event)}
                            >
                                {/*{format === '' &&*/}
                                {/*    <MenuItem value=''>Select...</MenuItem>*/}
                                {/*}*/}
                                {formatOptions.map((option, index) =>
                                    (
                                        <MenuItem
                                            key={index}
                                            value={option?.value}
                                        >
                                            {option?.name}
                                        </MenuItem>
                                    )
                                )}
                            </Select>
                        </FormControl>
                        }
                    </LabelledField>
                    <LabelledField label={t("commons.whenClicked")} className='labelField'>
                        {isArrayNotEmpty(targetOptions) &&
                        <FormControl sx={{ mt: 1, mb: 1, width: "100%" }} size="small">
                            <Select
                                labelId='document-select'
                                id='document-style-select'
                                value={target}
                                fullWidth={true}
                                variant='outlined'
                                onChange={(event) => onChangeTarget(event)}
                            >
                                {/*{localState?.settings?.target === '' &&*/}
                                {/*    <MenuItem value=''>Select...</MenuItem>*/}
                                {/*}*/}
                                {targetOptions.map((option, index) =>
                                    (
                                        <MenuItem
                                            key={index}
                                            value={option?.value}
                                        >
                                            {option?.name}
                                        </MenuItem>
                                    )
                                )}
                            </Select>
                        </FormControl>
                        }
                    </LabelledField>
                </Popover>
            </div>
        </Fragment>
    );
};

export { SettingsDialog };
